module.exports = __webpack_public_path__ + "static/media/index.a8cd3d51.cjs";